// Module
var code = "<select class=\"form-control input-medium\" data-bind=\"options: _colorModels, value: _colorModel\"></select> <!--ko with: _colorModelImpl --> <!--ko template: {html: $data.GetTemplate.bind($data)}--><!--/ko--> <!--/ko-->";
// Exports
export default code;